import { useQuery } from '@apollo/client';
import ReactSelect, { components } from 'react-select';
import { GET_INFLUENCERS_NAMES } from '../api/graphql/query';
import _ from 'lodash';
import { useState } from 'react';

const ValueContainer = (props) => (
  <components.ValueContainer {...props} className="px-2 py-0 leading-none" />
);

const SingleValue = (props) => (
  <components.SingleValue {...props} className="p-0 leading-none" />
);

const Control = (props) => (
  <components.Control
    {...props}
    className="border border-gray-200 rounded-lg focus:border-none p-0 flex items-center shadow-none min-h-0"
  />
);

const IndicatorsContainer = (props) => (
  <components.IndicatorsContainer {...props} className="p-0 m-0" />
);

const ClearIndicator = (props) => (
  <components.ClearIndicator {...props} className="px-0" />
);

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props} className="px-0 pr-2" />
);

const IndicatorSeparator = (props) => (
  <components.IndicatorSeparator {...props} className="hidden" />
);

const Input = (props) => (
  <components.Input
    {...props}
    className=" appearance-none rounded-lg text-black border-none p-0 leading-none m-0"
  />
);

const Placeholder = (props) => (
  <components.Placeholder {...props} className="appearance-none text-black" />
);

const InfluencerSelectWrapper = ({ influencerId, className, onChange }) => {
  const { data, loading } = useQuery(GET_INFLUENCERS_NAMES);

  const options =
    data?.creators
      ?.filter((c) => !!c.firstName?.length || !!c.lastName?.length)
      ?.map((i) => ({
        label: `${i.firstName} ${i.lastName}`,
        value: i.id,
      })) ?? [];

  const [id, setId] = useState(influencerId);

  const selected = options.find((o) => o.value === id);

  return (
    <ReactSelect
      className={className}
      isClearable
      isSearchable
      isLoading={loading}
      value={selected}
      placeholder="Select creator"
      options={_.sortBy(options, (v) => v.label)}
      onChange={(option) => {
        onChange(option);
        setId(option);
      }}
      components={{
        Input,
        Control,
        SingleValue,
        ValueContainer,
        IndicatorSeparator,
        IndicatorsContainer,
        DropdownIndicator,
        ClearIndicator,
        Placeholder,
      }}
    />
  );
};

export default InfluencerSelectWrapper;
